import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Gallery';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        const gallery = new Swiper(this.$el, {
            loop: true,
            speed: 600,
            grabCursor: true,
            slidesPerView: "auto",
            centerSlides: true,
            spaceBetween: 60,
            slideClass: 'js-gallery-slide',
            wrapperClass: 'js-gallery-wrap',
            pagination: {
                el: '.js-gallery-pagination',
                type: 'bullets',
                clickable: true
            }
        });
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
